module.exports = __webpack_public_path__ + "96a0cc434adcfd0c16c8a670b3a79150.png";